import React, { createContext, useCallback, useContext, useState } from 'react';

import type { Interval, Task } from '@/types/types';

interface IntervalDrawerState {
  interval: Interval;
  taskId?: Task['id'];
}

interface IntervalDrawerContextValue {
  state: IntervalDrawerState | null;
  open: (state: IntervalDrawerState) => void;
  close: () => void;
}

const IntervalDrawerContext = createContext<IntervalDrawerContextValue | null>(null);

export function IntervalDrawerProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<IntervalDrawerState | null>(null);

  const open = useCallback((next: IntervalDrawerState) => {
    setState(next);
  }, []);

  const close = useCallback(() => {
    setState(null);
  }, []);

  return (
    <IntervalDrawerContext.Provider value={{ state, open, close }}>
      {children}
    </IntervalDrawerContext.Provider>
  );
}

export function useIntervalDrawerContext() {
  const ctx = useContext(IntervalDrawerContext);
  if (!ctx) {
    throw new Error('useIntervalDrawerContext must be used within IntervalDrawerProvider');
  }
  return ctx;
}
